<template>
    <div>
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <div class="row align-items-lg-center mb-n3 mb-lg-0">
            <div class="col-md-6 mb-3 mb-lg-0">
                <h3 class="mb-3 font-weight-bold">
                    {{ $t(`dashboard.${keyMainTranslation}`) }}
                </h3>
                <span class="text-title">
                    {{ data[keyMain] }}
                </span>
            </div>
            <div class="col-md-6 mb-3 mb-lg-0">
                <ul class="list list-lined">
                    <li
                        v-for="[item, key] in Object.entries(keyItems)"
                        :key="item"
                        class="text-smaller"
                    >
                        <span>
                            {{ $t(`dashboard.${item}`) }}
                        </span>
                        <span class="font-weight-semi-bold">
                            {{ data[key] }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import UiSpinner from '../ui/spinner.vue';

export default {
    name: 'WidgetStatsOverview',
    components: {
        UiSpinner,
    },
    props: {
        keyItems: {
            type: Object,
            required: true,
        },
        keyMainTranslation: {
            type: String,
            required: true,
        },
        keyMain: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: [],
            isLoading: true,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: this.query });

            this.data = data;
            this.isLoading = false;
        },
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>
